// extracted by mini-css-extract-plugin
export default {"registrationPopover":"RegistrationTachographModal_registrationPopover__SpZzu","serviceType":"RegistrationTachographModal_serviceType__zlHE7"};